import { Brand, BrandFormData, BrandStatus } from '../../types/common.types';

export const getFilteredAndSortedBrands = (
  brands: Brand[],
  searchTerm: string,
  sortBy: string,
  sortOrder: 'ASC' | 'DESC'
) => {
  return brands
    .filter(brand => {
      if (!searchTerm.trim()) return true;
      const query = searchTerm.toLowerCase();
      return (
        brand.name.toLowerCase().includes(query) ||
        brand.id.toString().includes(query) ||
        brand.order_number.toString().includes(query) ||
        brand.azk_count.toString().includes(query) ||
        brand.active_azk_count.toString().includes(query)
      );
    })
    .sort((a, b) => {
      if (!sortBy) return 0;

      let aValue: any = (a as any)[sortBy];
      let bValue: any = (b as any)[sortBy];

      if (sortBy === 'id' || sortBy === 'order_number' || sortBy === 'azk_count' || sortBy === 'active_azk_count') {
        aValue = Number(aValue) || 0;
        bValue = Number(bValue) || 0;
        if (aValue < bValue) return sortOrder === 'ASC' ? -1 : 1;
        if (aValue > bValue) return sortOrder === 'ASC' ? 1 : -1;
        return 0;
      } else {
        const result = String(aValue || '').localeCompare(String(bValue || ''), 'uk', { sensitivity: 'base' });
        return sortOrder === 'ASC' ? result : -result;
      }
    });
};

export const getPlaceholdersValues = (brandsData: Brand[]) => {
  if (!Array.isArray(brandsData) || brandsData.length === 0) {
    return { id: 1, order: 1 };
  }

  const maxId = Math.max(...brandsData.map(brand => Number(brand.id) || 0));
  const maxOrder = Math.max(...brandsData.map(brand => Number(brand.order_number) || 0));

  return { id: maxId + 1, order: maxOrder + 1 };
};

export const getUpdatedBrands = (list: Brand[], id: number, field: string, value: any) =>
  list.map(b => (b.id === id ? { ...b, [field]: value } : b));

export const getChangedRows = (updatedList: Brand[], originalRef: React.MutableRefObject<Brand[]>) => {
  return updatedList
    .filter(b => {
      const orig = originalRef.current.find(o => o.id === b.id);
      if (!orig) return true;
      return orig.name !== b.name || orig.status !== b.status || orig.order_number !== b.order_number;
    })
    .map(b => b.id);
};

export const getTransformedCreateData = (data: BrandFormData) => {
  return {
    id: Number(data.brandId),
    name: data.brandName,
    order_number: Number(data.order),
    status: BrandStatus.ACTIVE,
    azk_count: 0,
    active_azk_count: 0
  };
};

export const validateBrandData = (brand: Partial<Brand>): string[] => {
  const errors: string[] = [];

  if (brand.name !== undefined && (!brand.name || brand.name.trim().length === 0)) {
    errors.push("Назва обов'язкова");
  }

  if (brand.order_number !== undefined && (brand.order_number < 0 || !Number.isInteger(brand.order_number))) {
    errors.push("Порядок повинен бути невід'ємним цілим числом");
  }

  if (brand.id !== undefined && (brand.id <= 0 || !Number.isInteger(brand.id))) {
    errors.push('ID повинен бути позитивним цілим числом');
  }

  if (brand.status !== undefined && !Object.values(BrandStatus).includes(brand.status)) {
    errors.push(`Статус повинен бути одним з: ${Object.values(BrandStatus).join(', ')}`);
  }

  return errors;
};

export const columnNames = [
  { key: 'id', label: 'ID', className: 'brands-col-id' },
  { key: 'name', label: 'Назва', className: 'brands-col-name' },
  { key: 'order_number', label: 'Порядковий №', className: 'brands-col-order' },
  { key: 'azk_count', label: 'Кількість АЗК', className: 'brands-col-azk-count' },
  { key: 'active_azk_count', label: 'Кількість роб. АЗК', className: 'brands-col-active-azk' },
  { key: 'status', label: 'Статус', className: 'brands-col-status' }
];
